exports = module.exports = require("../../node_modules/_css-loader@0.27.3@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "h3[data-v-cf0d5cac]:after{content:\" \";width:14px;height:6px;background-color:#409eff;display:block;margin:12px 0 20px}img[data-v-cf0d5cac]{border-radius:3px}.doc_h[data-v-cf0d5cac]{background-color:#fffcef;border:1px solid #fc9;color:#f96;padding:5px 3%;font-size:12px;line-height:150%;text-align:center;margin-bottom:15px;font-weight:400}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.27.3@css-loader?minimize!./~/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cf0d5cac","scoped":true,"hasInlineConfig":false}!./~/_sass-loader@7.1.0@sass-loader/lib/loader.js!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/components/people1.vue
// module id = 180
// module chunks = 1